<template>
  <div class="mt-1 md:mt-5">
    <!-- TODO: Gráfico -->
    <nav class="mt-3 flex space-x-4" aria-label="Tabs">
      <a
        v-for="(c, index) in menu"
        :key="index"
        :class="
          c.active
            ? 'border-ontick-blue-500 text-ontick-carbon-900 border-b-2 dark:text-white'
            : 'text-gray-400 hover:text-gray-500'
        "
        class="cursor-pointer px-1 py-1 text-base font-medium"
        @click="activeCharts(c)"
      >
        {{ c.label }}
      </a>
    </nav>
    <div class="details_chart" v-for="(c, index) in menu" :key="index">
      <v-chart v-if="c.active && c.label == 'Linha'" autoresize :option="chartLine(equityCurve)"></v-chart>
      <v-chart v-if="c.active && c.label == 'Barra'" autoresize :option="chartBar(equityCurve)"></v-chart>
      <transition name="slide-fade" mode="out-in">
        <template v-if="c.active && c.label == 'Heatmap'">
          <marketplace-details-heatmap-component
            v-if="Object.keys(heatmapChart.data).length > 0 && heatmapChart.periodYear != 'ALL'"
            :product="heatmapChart.data"
            :periodYear="heatmapChart.periodYear"
            :periodMonth="heatmapChart.periodMonth"
            @selectSpecificDate="$emit('selectedPeriod')"
          />
        </template>
      </transition>
    </div>
  </div>
</template>

<script>
// import ECharts from "@/app/shared/components/chart/echarts";
import { mapState } from "vuex";
import moment from "moment";
import VChart from "vue-echarts";
import { use, graphic } from "echarts/core";
import { CanvasRenderer, SVGRenderer } from "echarts/renderers";
import { LineChart, BarChart } from "echarts/charts";
import { GridComponent, DatasetComponent, DataZoomComponent, BrushComponent } from "echarts/components";
import MarketplaceDetailsHeatmapComponent from "./marketplace-details-heatmap.component.vue";

use([
  CanvasRenderer,
  SVGRenderer,
  LineChart,
  BarChart,
  GridComponent,
  DatasetComponent,
  DataZoomComponent,
  BrushComponent,
]);

export default {
  name: "detailsChart",
  components: {
    VChart,
    MarketplaceDetailsHeatmapComponent,
  },
  props: {
    menu: { type: Array, default: [] },
    equityCurve: { type: Array, default: [] },
    splitDate: { type: String, default: null },
    analysisType: { type: String, default: null },
    heatmapChart: { type: Object, required: true },
  },
  data() {
    return {
      dateChart: [],
    };
  },
  watch: {
    equityCurve: {
      immediate: true,
      handler(values) {
        this.dateChart = values.map(({ datetime }) => datetime);
        return values;
      },
    },
  },
  computed: {
    ...mapState({
      accountTypes: (state) => state.accountTypes,
      config: (state) => state.config,
    }),
  },
  methods: {
    activeCharts(value) {
      this.menu.forEach((item) => {
        item.active = false;
      });
      value.active = true;
      this.$emit("selectedChart", { chart: value.label });
    },
    chartLine(value) {
      let color_selected = "";
      let color_line = "";

      let dark = this.config.ui_theme == "DARK" ? this.config.theme_chart.dark : this.config.theme_chart.light;

      let conditional_data = [];
      let conditional_line = [];

      if (this.splitDate) {
        conditional_line = [
          {
            name: "Backtest",
            xAxis: this.splitDate,
            symbol: "none",
          },
        ];
        conditional_data = [
          [
            {
              name: "Backtest",
              xAxis: this.dateChart[0],
            },
            {
              xAxis: this.splitDate,
            },
          ],
          [
            {
              name: "Paper trade",
              xAxis: this.splitDate,
            },
            {
              xAxis: this.dateChart[this.dateChart.length - 1],
            },
          ],
        ];
      }

      if (value) {
        if (value[0].result < value[value.length - 1].result) {
          color_selected = "rgba(25, 214, 132, 0.5)";
          color_line = "#19D684";
        } else {
          color_selected = " rgba(235, 77, 75, 0.5)";
          color_line = "#e74c3c";
        }
      } else {
        return;
      }

      let grid = this.$screen.portrait
        ? {
            left: "13%",
            right: "0%",
            bottom: "10%",
            top: "17.5%",
          }
        : {
            left: "6%",
            right: "0%",
            bottom: "10%",
            top: "17.5%",
          };

      let option = {
        dataset: {
          dimensions: ["datetime", "result"],
          source: value,
        },

        dataZoom: [
          {
            show: false,
            start: 0,
            end: 100,
          },
          {
            type: "inside",
            start: 0,
            end: 100,
          },
          {
            show: false,
            yAxisIndex: 0,
            filterMode: "empty",
            width: 12,
            height: "50%",
            showDataShadow: false,
            left: "99%",
          },
        ],

        brush: {
          show: false,
          toolbox: ["lineX", "clear"],
          throttleType: "debounce",
          throttleDelay: 500,

          xAxisIndex: "all",
          brushLink: "all",
        },

        grid: grid,

        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            axisLabel: {
              color: dark.font_color,
              fontSize: 10,
              fontFamily: "Poppins",
              formatter: function (value) {
                let date;
                date = moment(value).format("L");
                return date;
              },
            },
            splitLine: {
              show: false,

              lineStyle: {
                // color: "rgba(255, 255, 255, 0.2)",
              },
            },
          },
        ],
        yAxis: {
          type: "value",
          scale: true,

          nameTextStyle: {
            fontSize: 10,
            show: false,
          },
          axisLabel: {
            color: dark.font_color,
            fontSize: 10,
            fontFamily: "Poppins",
            formatter: function (value) {
              value = value.toLocaleString("pt-BR", {
                minimumFractionDigits: 0,
              });
              return value;
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: dark.chart_2,
            },
          },
          minorSplitLine: {
            show: false,
          },
        },
        series: [
          {
            encode: {
              y: "result",
              x: "datetime",
            },

            dimensions: ["datetime", "result"],
            type: "line",
            lineStyle: {
              color: color_line,
              opacity: 0.9,
              width: 1.5,
            },
            symbol: "circle",
            symbolSize: 0,
            sampling: "average",
            itemStyle: {
              color: "#057bbf",
            },

            markArea:
              conditional_data.length > 0
                ? {
                    label: {
                      color: dark.font_color,
                    },
                    itemStyle: {
                      color: dark.chart_2,
                    },
                    data: conditional_data,
                  }
                : {},

            markLine:
              conditional_line.length > 0
                ? {
                    label: {
                      show: false,
                    },
                    itemStyle: {
                      // color: "rgba(255, 255, 255, 0.6)",
                    },
                    symbol: "none",
                    data: conditional_line,
                  }
                : {},

            areaStyle: {
              color: new graphic.LinearGradient(0, 0, 0, 1.2, [
                {
                  offset: 0,
                  color: color_selected,
                },
                {
                  offset: 1,
                  color: dark.chart_2,
                },
              ]),
            },
            animationDelay: function (idx) {
              return idx * 2000;
            },
          },
        ],
        animationEasing: "elasticOut",
        animationDelayUpdate: function (idx) {
          return idx * 5;
        },
      };

      return option;
    },
    chartBar(value) {
      let color_selected;
      let color_line;

      let dark = this.config.ui_theme == "DARK" ? this.config.theme_chart.dark : this.config.theme_chart.light;

      let conditional_data = [];
      let conditional_line = [];

      // if (this.splitDate) {
      //   conditional_line = [
      //     {
      //       name: "Backtest",
      //       xAxis: this.splitDate,
      //       symbol: "none",
      //     },
      //   ];
      //   conditional_data = [
      //     [
      //       {
      //         name: "Backtest",
      //         xAxis: this.dateChart[0],
      //       },
      //       {
      //         xAxis: this.splitDate,
      //       },
      //     ],
      //     [
      //       {
      //         name: "Paper trade",
      //         xAxis: this.splitDate,
      //       },
      //       {
      //         xAxis: this.dateChart[this.dateChart.length - 1],
      //       },
      //     ],
      //   ];
      // }

      if (value) {
        if (value[0].pnl < value[value.length - 1].pnl) {
          color_selected = "rgba(25, 214, 132, 0.5)";
          color_line = "#19D684";
        } else {
          color_selected = " rgba(235, 77, 75, 0.5)";
          color_line = "#e74c3c";
        }
      } else {
        return;
      }

      let option = {
        dataset: {
          dimensions: ["datetime", "pnl"],
          source: value,
        },
        dataZoom: [
          {
            show: false,
            start: 0,
            end: 100,
          },
          {
            type: "inside",
            start: 0,
            end: 100,
          },
          {
            show: false,
            yAxisIndex: 0,
            filterMode: "empty",
            width: 12,
            height: "50%",
            showDataShadow: false,
            left: "99%",
          },
        ],

        grid: {
          left: "4%",
          right: "0%",
          bottom: "10%",
          top: "10%",
        },

        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLabel: {
              color: dark.font_color,
              fontSize: 10,
              fontFamily: "Poppins",
              formatter: function (value) {
                let date;
                date = moment(value).format("L");
                return date;
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: {
          type: "value",
          scale: true,

          nameTextStyle: {
            show: false,
          },
          axisLabel: {
            color: dark.font_color,
            fontSize: 10,
            fontFamily: "Poppins",
            formatter: function (value) {
              value = value.toLocaleString("pt-BR", {
                minimumFractionDigits: 0,
              });
              return value;
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: dark.chart_2,
            },
          },
          minorSplitLine: {
            show: false,
          },
        },
        series: [
          {
            encode: {
              y: "pnl",
              x: "datetime",
            },

            dimensions: ["datetime", "pnl"],
            type: "bar",
            lineStyle: {
              color: color_line,
              opacity: 0.9,
              width: 2,
            },
            symbol: "circle",
            symbolSize: 0,
            sampling: "average",
            itemStyle: {
              color: function (params) {
                let color_selected;
                let rgba = { g: 0, r: 0, b: 0, y: 0 };

                if (params.data.pnl > 0) {
                  color_selected = "rgba(25, 214, 132, 0.8)";
                  rgba.g = 0;
                  rgba.r = 0;
                  rgba.b = 0;
                  rgba.y = 1;
                } else {
                  color_selected = "rgba(235, 77, 75, 0.8)";
                  rgba.g = 0;
                  rgba.r = 1;
                  rgba.b = 0;
                  rgba.y = 0;
                }
                return new graphic.LinearGradient(rgba.g, rgba.r, rgba.b, rgba.y, [
                  { offset: 0.1, color: color_selected },
                  { offset: 1, color: "rgba(32, 42, 55, 0.8)" },
                ]);
              },
            },

            markArea:
              conditional_data.length > 0
                ? {
                    itemStyle: {
                      color: dark.chart_2,
                    },
                    label: {
                      color: dark.font_color,
                      fontFamily: "Poppins",
                    },
                    data: conditional_data,
                  }
                : {},

            markLine:
              conditional_line.length > 0
                ? {
                    label: {
                      show: false,
                    },
                    itemStyle: {
                      color: "#057bbf",
                    },
                    symbol: "none",
                    data: conditional_line,
                  }
                : {},

            areaStyle: {
              color: new graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: color_selected,
                },
                {
                  offset: 1,
                  color: dark.chart_2,
                },
              ]),
            },
            animationEasing: "elasticOut",

            animationDelay: function (idx) {
              return idx * 5;
            },
          },
        ],
        animationEasing: "elasticOut",
        animationDelayUpdate: function (idx) {
          return idx * 5;
        },
      };

      return option;
    },
  },
};
</script>

<style lang="scss" scoped>
.details_chart {
  margin-top: 1.5rem;
  .echarts {
    width: 100%;
    height: 280px;
  }
}
</style>
